<footer class="footer">
  <div class="d-sm-flex justify-content-center justify-content-sm-between">
    <div class="text-muted text-center text-sm-left d-block d-sm-inline-block">
      <span>{{'copyrights' | translate}} © {{currentYear}} {{'tableegh' | translate}}.
        {{'allRightsReserved' | translate}}</span>

      <!-- <a href="https://www.bootstrapdash.com/" target="_blank">
        Bootstrap Dash
      </a>.
      <span translate>All rights reserved</span> -->
    </div>
    <!-- <div class="float-none float-sm-right d-block mt-1 mt-sm-0 text-center text-dark">
      <span translate>Hand-crafted & made with</span>
      <i class="mdi mdi-heart text-danger"></i>
    </div> -->
  </div>
</footer>
